export default __webpack_public_path__ + "static/media/job_1.8fa1472e.png";